import { buildUserId } from '../lib/buildUserId'

const USER_ID_SEPARATOR = '-'

export function isSubuser({ userId, companyId }: { userId: string; companyId: string }): boolean {
  return (
    buildUserId({ userId, companyId, includeSubuser: true }).split(USER_ID_SEPARATOR).length === 3
  )
}
